import React from 'react';

import Button from 'react-bootstrap/Button';
import { default as BSModal } from 'react-bootstrap/Modal';

const Modal = ({ showModal, setShowModal, handleYes, handleNo, text: { body, yes, no } }) => {

  return (
    <>
      <BSModal show={showModal} onHide={() => setShowModal(false)}>
        <BSModal.Header closeButton>
          <BSModal.Title>Warning</BSModal.Title>
        </BSModal.Header>
        <BSModal.Body>
          {body}
        </BSModal.Body>
        <BSModal.Footer>
          <Button variant="secondary" onClick={handleNo}>
            {no}
          </Button>
          <Button variant="primary" onClick={handleYes}>
            {yes}
          </Button>
        </BSModal.Footer>
      </BSModal>
    </>
  );
}

export { Modal };
